export const adalConfig = {
    tenant: '5ac5a0c0-3ee7-4848-be5e-226c80860f44',
    clientId: '27bb097a-95c9-45bb-b80f-29ab18865a6f',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/#/',
    additionalQueryParameter: 'nux=1',
    cacheLocation: 'localStorage' as const,
};
